import { render, staticRenderFns } from "./ProjectsArchive.vue?vue&type=template&id=5561cb3d"
import script from "./ProjectsArchive.vue?vue&type=script&lang=js"
export * from "./ProjectsArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports